export enum PurchaseItemObject {
    EXPERIENCE = "scheduled_experience_purchase_item",
    EQUIPMENT = "equipment_purchase_item",
    MEMBERSHIP = "membership_purchase_item",
    GIFT = "gift_purchase_item",
    STORE_CREDIT = "store_credit_purchase_item",
    ORDER = "experience_purchase_item",
    WARE = "ware_purchase_item",
}
